import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useData } from "../contexts/DataContext";

const GiveawayAnnouncement = () => {
  const { BACKEND_URL } = useData();
  const [giveaway, setGiveaway] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGiveaway = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/giveaways/active`);
        const data = await response.json();
        setGiveaway(data);
      } catch (error) {
        console.error("Error fetching giveaway:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGiveaway();
  }, [BACKEND_URL]);

  if (loading || !giveaway) {
    return null;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const now = new Date();
  const endDate = new Date(giveaway.end_date + 'Z');
  const drawingDate = giveaway.drawing_date
    ? new Date(giveaway.drawing_date + 'Z')
    : null;
  const winnerAnnouncedAt = giveaway.winner_announced_at
    ? new Date(giveaway.winner_announced_at + 'Z')
    : null;

  const isActive = now <= endDate;
  const hasWinner = giveaway.winner_user_id && winnerAnnouncedAt;

  let message, bgColor, textColor;

  if (hasWinner) {
    message = `🎉 Giveaway Winner Announced! Check the results.`;
    bgColor = "bg-gradient-to-r from-green-400 to-emerald-500";
    textColor = "text-white";
  } else if (!isActive && drawingDate && now < drawingDate) {
    message = `🎊 Giveaway ended! Winner drawing on ${formatDate(
      giveaway.drawing_date
    )}.`;
    bgColor = "bg-gradient-to-r from-yellow-300 to-orange-400";
    textColor = "text-gray-800";
  } else if (!isActive) {
    message = `🎊 Giveaway ended! Winner announcement coming soon.`;
    bgColor = "bg-gradient-to-r from-yellow-300 to-orange-400";
    textColor = "text-gray-800";
  } else {
    message = `🎉 ${giveaway.title} - Win a ${giveaway.prize_description}! Enter by posting reviews or classifieds. Ends ${formatDate(
      giveaway.end_date
    )}.`;
    bgColor = "bg-gradient-to-r from-purple-500 to-pink-500";
    textColor = "text-white";
  }

  return (
    <Link to="/giveaway-rules">
      <div
        className={`${bgColor} ${textColor} p-3 text-center text-sm font-semibold shadow-lg hover:shadow-xl transition-shadow duration-200 cursor-pointer mb-4 rounded-lg`}
      >
        <p className="text-lg">{message}</p>
        <p className="text-sm mt-1 opacity-90">
          Click here for official rules and entry details!
        </p>
      </div>
    </Link>
  );
};

export default GiveawayAnnouncement;
